var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFollowOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1340,307.8a20,20,0,1,1,20,20A20,20,0,0,1,1340,307.8Zm3.626,0A16.374,16.374,0,1,0,1360,291.426,16.415,16.415,0,0,0,1343.626,307.8Zm14.737,7.593V309.9h-5.495A1.853,1.853,0,0,1,1351,308.03a1.788,1.788,0,0,1,1.868-1.867h5.495v-5.495a1.868,1.868,0,1,1,3.736,0v5.495h5.495a1.868,1.868,0,1,1,0,3.736H1362.1v5.495a1.868,1.868,0,1,1-3.736,0Z",
    transform: "translate(-1338 -287)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFollowOutline);
export default __webpack_public_path__ + "static/media/icon-follow-outline.c34b227c.svg";
export { ForwardRef as ReactComponent };